import { BASE_URL } from '../constants';

const getOTP = async mobile => {
  try {
    const postData = {
      mobile,
    };

    const response = await fetch(`${BASE_URL}/api/v2/users/requestOTP`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(postData),
    });

    const json = await response.json();

    if (json.error) {
      throw new Error(json.error.errorMessage);
    }

    return json.data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export default getOTP;
